import { Box, ButtonBase, Paper, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PipelineBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  minWidth: '300px',
  width: '300px',
  textAlign: 'center',
}));

export const PipelineTitle = styled(ButtonBase)(({ theme }) => ({
  borderRadius: '20px',
  backgroundColor: theme.palette.primary.main,
  height: '56px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.primary.contrastText,
  fontWeight: '600',
  fontSize: 16,
  position: 'relative',
  fontFamily: 'Montserrat',
}));

export const PipelinePaper = styled(Paper)(({ theme }) => ({
  height: '100%',
  overflowY: 'auto',
  backgroundColor: '#8B8C8E',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '10px',
  padding: '8px',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
}));

export const StyledSkeleton = styled(Skeleton)(() => ({
  height: 230,
  borderRadius: 5,
  width: '100%',
  backgroundColor: 'white',
  margin: '8px 0 16px',
  padding: '16px',
}));

interface SortIconsProps {
  selectedchild: 'asc' | 'desc' | 'none';
}

export const SortIcons = styled(Box)<SortIconsProps>(
  ({ theme, selectedchild }) => {
    const inactiveColor = '#8D9295';
    const activeColor = theme.palette.secondary.main;

    return {
      height: '26px',
      position: 'absolute',
      right: 12,
      display: 'flex',
      span: {
        fontSize: 16,
        fontWeight: 600,
        transition: theme.transitions.create('color', {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.standard,
        }),
      },
      'span:nth-of-type(1)': {
        alignSelf: 'end',
        marginRight: -8,
        color:
          selectedchild === 'asc' || selectedchild === 'none'
            ? inactiveColor
            : activeColor,
      },
      'span:nth-of-type(2)': {
        color:
          selectedchild === 'desc' || selectedchild === 'none'
            ? inactiveColor
            : activeColor,
      },
    };
  }
);
